<template>
<div class="inner-content m-t-xl b-gray-1 pay-success-wrp" >
  <div class="bg-gray-4 pay-success-header">
    <img class="pay-scucess-img" src="../assets/fin.png">{{orderPayStatus}}
  </div>
  <div class="pay-success-body text-big">
    <ul class="pay-success-ul">
      <li>付款方式：<span class="text-price">{{orderPayTypes[order.orderPay.payMethod]}}</span></li>
      <li>订单金额: <span class="text-price">￥{{order.price / 100 || ''}}</span></li>
    </ul>
    <div class="order-list-link-wrp">您可以查看:  <router-link class="link-text" :to="{name: 'OrderList'}">我的订单</router-link></div>
    <hr>
    <div class="pay-success-tip">
      <span class="text-price">安全提醒：</span> 安全提醒：下单成功后，时尚新娘不会以订单异常、系统升级等问题为由，要求您点击任何链接进行退款操作。请谨防诈骗！
    </div>
  </div>
</div>
</template>
<script>
import toastr from 'mini-toastr';
import orderService from '../service/order';
import { ORDER_PAY_TYPE } from '../constants';

export default {
  name: 'PaySuccess',
  created() {
    orderService.getOne(this.$route.params.id)
      .then((resp) => {
        this.order = resp.data.order_info;
        this.orderPay = resp.data.order_info.orderPay;
        if (this.orderPay.status === 1) {
          this.orderPayStatus = '您已成功付款';
        } else {
          this.orderPayStatus = '等待支付中';
        }
      }, (resp) => {
        toastr.error(resp, '获取订单信息出错');
      });
  },
  data() {
    return {
      order: {},
      orderPayTypes: ORDER_PAY_TYPE,
      orderPay: {},
      orderPayStatus: undefined,
    };
  },
};
</script>
<style>
.pay-success-wrp {
  margin-bottom: 260px;
}
.pay-success-header {
  height: 100px;
  line-height: 100px;
  font-size: 24px;
  color: #252525;
  font-weight: 600;
}
.pay-scucess-img {
  vertical-align: middle;
  margin: 0 30px;
}
.pay-success-body {
  padding: 10px 25px 40px 25px;
}
.pay-success-ul {
  line-height: 40px;
}
.pay-success-ul > li {
  padding-left: 1em;
}
.order-list-link-wrp {
  margin: 10px 0 25px 58px;
}
.inner-content .order-list-link-wrp .link-text {
  color: #427bc9;
}
.pay-success-tip {
  padding: 40px 0 0 25px;
}
</style>



// WEBPACK FOOTER //
// PaySuccess.vue?238eba0e